import React, { useEffect } from 'react'
import { FaUserGraduate } from 'react-icons/fa';
import { HiOutlineDesktopComputer } from 'react-icons/hi'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Aos from 'aos';
import 'aos/dist/aos.css'

const Timeline = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])

  return (
    <div name="experience" className=" w-full bg-[#0a192f] text-gray-300 pt-48 pb-96">
      <div className="max-w-[1000px]  mx-auto p-4 w-full flex flex-col justify-center h-full">
        <div className="pb-4 " data-aos='slide-right'>
          <p className="text-4xl font-bold inline border-b-4 border-pink-600">
            Education & Experience
          </p>
        </div>
        <div className='w-full'>
          <VerticalTimeline lineColor='rgb(219 39 119)'>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#0a192f', color: 'rgb(209 213 200)', boxShadow: '0 0 3px 3px rgb(29 78 216)' }}
              contentArrowStyle={{ borderRight: '10px solid rgb(29 78 216)' }}
              date="2022.11 - present"
              iconStyle={{ background: 'rgb(219 39 119)', color: 'rgb(209 213 219)' }}
              icon={<HiOutlineDesktopComputer />}
            >
              <h3 className="vertical-timeline-element-title font-bold">Lead developer</h3>
              <h4 className="vertical-timeline-element-subtitle">IoT Logistics LLC</h4>
              <p>
                Online publish platform development, Team work, Web<span className='number'>3</span>Auth, Netlify, Bubble, IPFS(Pinata)
              </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#0a192f', color: 'rgb(209 213 219)', boxShadow: '0 0 3px 3px rgb(29 78 216)' }}
              contentArrowStyle={{ borderRight: '10px solid  rgb(29 78 216)' }}
              date="2022.8 - 2022.11"
              iconStyle={{ background: 'rgb(219 39 119)', color: 'rgb(209 213 219)', }}
              icon={<HiOutlineDesktopComputer />}>
              <h3 className="vertical-timeline-element-title font-bold">Full stack & Blockchain Developer</h3>
              <h4 className="vertical-timeline-element-subtitle">Basic Island</h4>
              <p>
                Basic Island Wallet, React/ReactNative, Non fungible Token, Fungible Token, Slack, Defi, Jira, Notion, Bitbucket.
              </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#0a192f', color: 'rgb(209 213 219)', boxShadow: '0 0 3px 3px rgb(29 78 216)' }}
              contentArrowStyle={{ borderRight: '10px solid  rgb(29 78 216)' }}
              date="2020.11 - 2022.4"
              iconStyle={{ background: 'rgb(219 39 119)', color: 'rgb(209 213 219)', }}
              icon={<HiOutlineDesktopComputer />}>
              <h3 className="vertical-timeline-element-title font-bold">Senior Full stack and Blockchain Developer</h3>
              <h4 className="vertical-timeline-element-subtitle">Poliance Software Development</h4>
              <p>
                React.js, Next,js, Multisig wallet, web3, NFT market place  NFT Minting, staking, token staking, Node.js, Firebase, vesting, DEX, DeFi, Blockchain games, launchpads, DAO, Figma, Trello, Miro
              </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#0a192f', color: 'rgb(209 213 219)', boxShadow: '0 0 3px 3px rgb(29 78 216)' }}
              contentArrowStyle={{ borderRight: '10px solid  rgb(29 78 216)' }}
              date="2019.4 - 2020.6"
              iconStyle={{ background: 'rgb(219 39 119)', color: 'rgb(209 213 219)', }}
              icon={<HiOutlineDesktopComputer />}>
              <h3 className="vertical-timeline-element-title font-bold">Blockchain Developer</h3>
              <h4 className="vertical-timeline-element-subtitle">Pythian</h4>
              <p>
                ERC<span className='number'>20</span>,
                ERC<span className='number'>721</span>,
                Upgradable Proxy Contract, layer2, crosschain
              </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#0a192f', color: 'rgb(209 213 219)', boxShadow: '0 0 3px 3px rgb(29 78 216)' }}
              contentArrowStyle={{ borderRight: '10px solid  rgb(29 78 216)' }}
              date="2018.7 - 2019.3"
              iconStyle={{ background: 'rgb(219 39 119)', color: 'rgb(209 213 219)', }}
              icon={<HiOutlineDesktopComputer />}>
              <h3 className="vertical-timeline-element-title font-bold">Software Enigneer</h3>
              <h4 className="vertical-timeline-element-subtitle">Poliance Software Development</h4>
              <p>
                 React/ReactNative, Express, MongoDB, Web3,js, NFT, IPFS, Hardhat, Truffle, Remix
              </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#0a192f', color: 'rgb(209 213 219)', boxShadow: '0 0 3px 3px rgb(29 78 216)' }}
              contentArrowStyle={{ borderRight: '10px solid  rgb(29 78 216)' }}
              date="2017.6 - 2018.5"
              iconStyle={{ background: 'rgb(219 39 119)', color: 'rgb(209 213 219)', }}
              icon={<HiOutlineDesktopComputer />}>
              <h3 className="vertical-timeline-element-title font-bold">Senior Fullstack Developer</h3>
              <h4 className="vertical-timeline-element-subtitle">SRM Technologies</h4>
              <p>
                Node.js, Express.js, MongoDB, Mysql, GraphQL, Firebase, Google Cloud, AWS
              </p>
            </VerticalTimelineElement>

            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: '#0a192f', color: 'rgb(209 213 219)', boxShadow: '0 0 3px 3px rgb(29 78 216)' }}
              contentArrowStyle={{ borderRight: '10px solid  rgb(29 78 216)' }}
              date="2013.4 - 2017.3"
              iconStyle={{ background: 'rgb(219 39 119)', color: 'rgb(209 213 219)', }}
              icon={<FaUserGraduate />}>
              <h3 className="vertical-timeline-element-title font-bold">Bachelor of Computer Science</h3>
              <h4 className="vertical-timeline-element-subtitle">Kyushu University</h4>
              <p>
                Completed Bachelor of Computer Science in Kyushu University
              </p>
            </VerticalTimelineElement>

          </VerticalTimeline>

        </div>
      </div>

    </div>
  )
}

export default Timeline
